import React from 'react'

/** @jsxImportSource @emotion/react */
import { css, } from '@emotion/core';
import { gsColors } from '../../../../styles/Variables';

const style = css`
  border: 0;
  border-bottom: 1px solid ${gsColors.black};
  color: ${gsColors.black};
  font-family: Brown, sans-serif;
  font-size: 16px;
  line-height: 20px;
  padding: 10px 0;
  width: 100%;

  ::placeholder {
    color: ${gsColors.slate};
  }

  ::-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${gsColors.slate};
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${gsColors.slate};
  }

  &:focus {
    outline: 0;
  }
`;

const Input = props => (<input css={style} {...props} />)
export default Input
